import React, { useEffect, useRef, useState } from "react";
import BottomNavigation from "../components/BottomNavigation";
import { obtenerTimeline, registrarAlcanceTimeline, registrarVistaTimeline } from "../api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useBottomSheet } from "../context/BottomSheetContext";
import { motion } from "framer-motion";

const Trending = () => {
  const [timeline, setTimeline] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const sentinelRef = useRef(null);
  const observerRefs = useRef({});
  const timers = useRef({});

  const { openBottomSheet } = useBottomSheet();
  const navigate = useNavigate();
  const { user } = useAuth();

  const LIMIT = 3;

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const idWall = entry.target.getAttribute("data-id");
        const lat = localStorage.getItem("userLat");
        const lang = localStorage.getItem("userLng");
  
        if (entry.isIntersecting) {
          timers.current[idWall] = setTimeout(() => {
            registrarVistaTimeline(parseInt(idWall), user?.id || null, lat, lang);
          }, 1500);
        } else {
          clearTimeout(timers.current[idWall]);
        }
      });
    }, { threshold: 0.6 });
  
    timeline.forEach(item => {
      const el = observerRefs.current[item.id_timeline];
      if (el) observer.observe(el);
    });
  
    return () => {
      observer.disconnect();
      Object.values(timers.current).forEach(clearTimeout);
    };
  }, [timeline]);  

  // Carga inicial
  useEffect(() => {
    const fetchInitial = async () => {
      if (user?.id) {
        setLoading(true);
        const data = await obtenerTimeline(user.id, 1, LIMIT);
        setTimeline(data);
        setPage(2);
        setHasMore(data.length === LIMIT);
        setLoading(false);
      }
    };
    fetchInitial();
  }, [user]);

  // Scroll infinito
  useEffect(() => {
    if (loading || !hasMore) return;

    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry.isIntersecting && !loadingMore) {
        loadMore();
      }
    });

    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [loading, loadingMore, hasMore]);

  const loadMore = async () => {
    if (!user?.id) return;
    setLoadingMore(true);
    const data = await obtenerTimeline(user.id, page, LIMIT);

    if (data.length > 0) {
      setTimeline(prev => [...prev, ...data]);
      setPage(prev => prev + 1);
      if (data.length < LIMIT) setHasMore(false);
    } else {
      setHasMore(false);
    }

    setLoadingMore(false);
  };

  const handleNotificaciones = () => {
    if (!user?.id) {
      toast.dismiss();
      toast.error("Debes iniciar sesión para ver tus notificaciones.");
      return;
    }
    navigate("/notificaciones");
  };

  return (
    <>
      <motion.div
        initial={{ y: "100%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: "100%", opacity: 0 }}
        transition={{ duration: 0.7, ease: "easeInOut" }}
      >
        <div className="app-container">
          <header className="app-header">
            <div className="left">
              <svg id="open-search" onClick={openBottomSheet} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m17 17l4 4M3 11a8 8 0 1 0 16 0a8 8 0 0 0-16 0" /></svg>
            </div>
            <div className="center">
              <img src="/assets/images/logocap.png" alt="Waze" className="logo" />
            </div>
            <div className="right" onClick={handleNotificaciones}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18.134 11C18.715 16.375 21 18 21 18H3s3-2.133 3-9.6c0-1.697.632-3.325 1.757-4.525S10.41 2 12 2q.507 0 1 .09M19 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6m-5.27 13a2 2 0 0 1-3.46 0" />
              </svg>
            </div>
          </header>

          <div className="timeline-container">
          {loading && timeline.length === 0 && (
            <div style={{ textAlign: "center", marginTop: 60 }}>
              <div className="custom-spinner"></div>
            </div>
          )}
            {timeline.length > 0 ? (
              <>
                {timeline.map(item => (
                  <div key={item.id_timeline} data-id={item.id_timeline} ref={el => (observerRefs.current[item.id_timeline] = el)} className="post">
                    <div className="post-header">
                      <img src={item.logo} alt={item.nombre_comercio} />
                      <div>
                        <div className="h-timeline">
                          <strong>{item.nombre_comercio}</strong>
                          <img src="/assets/images/verified.svg" className="verifiedUser" style={{ width: 300 }} alt="Verificado" />
                        </div>
                        <p onClick={() => navigate(`/comercio/app/${item.id_sucursal_predeterminada}`)}>
                        <svg style={{ verticalAlign: "sub" }} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                          <g fill="none" stroke="currentColor" strokeWidth="1">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M14.5 21v-5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5"></path>
                            <path d="M5 11v6c0 1.886 0 2.828.586 3.414S7.114 21 9 21h6c1.886 0 2.828 0 3.414-.586S19 18.886 19 17v-6M4.621 4.515c.182-.728.273-1.091.544-1.303C5.437 3 5.812 3 6.562 3h10.876c.75 0 1.125 0 1.397.212c.27.212.362.575.544 1.303l1.203 4.814c.097.388.146.581.135.739a1 1 0 0 1-.69.883c-.15.049-.354.049-.763.049c-.533 0-.8 0-1.023-.052a2 2 0 0 1-1.393-1.18c-.089-.212-.132-.47-.217-.983c-.024-.144-.036-.216-.05-.235a.1.1 0 0 0-.162 0c-.014.019-.026.09-.05.235l-.081.489l-.018.1A2 2 0 0 1 14.352 11h-.204a2 2 0 0 1-1.936-1.726l-.081-.49c-.024-.143-.036-.215-.05-.234a.1.1 0 0 0-.162 0c-.014.019-.026.09-.05.235l-.081.489l-.018.1A2 2 0 0 1 9.852 11h-.204A2 2 0 0 1 7.73 9.374l-.018-.1l-.081-.49c-.024-.143-.036-.215-.05-.234a.1.1 0 0 0-.162 0c-.014.019-.026.09-.05.235c-.085.514-.128.77-.217.983a2 2 0 0 1-1.392 1.18C5.536 11 5.27 11 4.736 11c-.409 0-.613 0-.763-.049a1 1 0 0 1-.69-.883c-.01-.158.038-.351.135-.739z"></path>
                          </g>
                        </svg>
                          De tus seguidos - {item.fecha_formateada}.
                        </p>
                      </div>
                    </div>
                    <p className="post-text">{item.descripcion}</p>
                    <div className="post-image">
                      <img src={item.imagen} alt="Imagen destacada" />
                    </div>
                    <div className="post-footer">
                      {item.url && (
                        <button className="info-button" 
                        onClick={() => {
                          const userData = JSON.parse(localStorage.getItem("userData") || "null");
                          const lat = localStorage.getItem("userLat");
                          const lang = localStorage.getItem("userLng");
                        
                          registrarAlcanceTimeline(item.id_timeline, userData?.id || null, lat, lang);
                        
                          const separator = item.url.includes("?") ? "&" : "?";
                          const utmUrl = `${item.url}${separator}utm_source=ubikalo&utm_medium=app&utm_campaign=ubikalo_wall`;
                          const finalUrl = utmUrl.startsWith("http") ? utmUrl : `https://${utmUrl}`;
                        
                          if (window.flutter_inappwebview) {
                            window.flutter_inappwebview.callHandler("abrirEnlaceExterno", finalUrl);
                          } else {
                            const a = document.createElement("a");
                            a.href = finalUrl;
                            a.target = "_blank";
                            a.rel = "noopener noreferrer";
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                          }
                        }}>
                          Más información
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                {loadingMore && (
                  <div style={{ textAlign: "center", margin: 40 }}>
                    <div className="custom-spinner"></div>
                  </div>
                )}
                <div ref={sentinelRef} style={{ height: 1 }}></div>
              </>
            ) : (
              !loading && (
                <div className="no-data-wrapper">
                  <div className="no-data">
                    <img src="/assets/images/empty.svg" alt="Sin seguidos" />
                    <p>
                      Aún no sigues ningún comercio.<br />
                      Cuando comiences a seguir, sus publicaciones aparecerán aquí.
                    </p>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </motion.div>
      <BottomNavigation/>
    </>
  );
};

export default Trending;